import * as React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import RoutePortal from "./RoutePortal";
import * as types from "../../constants/actionTypes";
import * as queryString from 'query-string';
import { getFirstName } from "../../helpers/formatting";

class RoutePortalLoggedIn extends RoutePortal {

    constructor(props, context) {
        super(props, context);
        this.updateAllowed = this.updateAllowed.bind(this);
        this.state = {
            ...(this.state ? this.state : {}),
            Allowed: true
        };
    }

    componentDidMount() {
        //debugger;
        //this.updateAllowed = this.updateAllowed.bind(this);
        this.setState({ Allowed: true });
        if (super.componentDidMount) {
            super.componentDidMount();
        }
        this.componentWillUpdate();
    }

    componentDidUpdate(prevProps, prevState) {
        if (super.componentDidUpdate) {
            super.componentDidUpdate(prevProps, prevState);
        }
        this.updateAllowed();
    }


    componentWillUpdate(oldProps) {
        //debugger;
        if (super.componentWillUpdate) {
            super.componentWillUpdate(oldProps);
        }
        this.updateAllowed();
        if (this.state.match) {
            if (!this.props.isLoggedIn) {
                let params = '';
                //debugger;
                //Handling query params after logged in.
                if (this.props.location && this.props.location.search) {
                    params = this.props.location.search;
                }
                //debugger;
                this.props.setRedirectUrl(this.state.match.url, params);
            }
        }
    }

    updateAllowed() {
        var { Allowed } = this.state;
        if (Allowed === undefined) { Allowed = false }
        var bAllowed = true;
        var { activeFeatures } = this.props;
        if (this.props.AllowedOnFeatures) {
            //debugger;
            bAllowed = false;
            var sFeatureList = this.props.AllowedOnFeatures.split(",");
            sFeatureList.forEach((sFeature) => {
                if (sFeature !== null || sFeature !== "") {
                    if (activeFeatures[sFeature]) {
                        bAllowed = true;
                    }
                }
            });
        }
        if (Allowed !== bAllowed) {
            this.setState({ Allowed: bAllowed });
        }
    }

    findXidFromProxyList(id) {
        const { myProxies, currentUser } = this.props;
        let isXidFound = false;
        let isXidIsCurrentUser = false;
        let XidName = null;
        if (myProxies && id) {
            for (let pl = 0; pl < myProxies.length; pl++) {
                let plUser = myProxies[pl];
                if (plUser && plUser.externalId && plUser.externalId.toLowerCase() === id.toLowerCase()) {
                    isXidFound = true;
                    isXidIsCurrentUser = currentUser && currentUser.externalId && currentUser.externalId.toLowerCase() === id.toLowerCase();
                    XidName = plUser && plUser.index && plUser.displayName ? getFirstName(plUser.displayName) : 'you';
                    break;
                }
            }
        }

        return { isXidFound, isXidIsCurrentUser, XidName };
    }


    render() {
        const { isProxyUser, activeFeatures, requireXID, RequireMyChart, isMyChartInActive } = this.props;
        const searchParams = queryString.parse(location.search != null && location.search != "" ? location.search : location.searchParms);
        //debugger;
        const xid = searchParams && searchParams["?xid"] ? searchParams["?xid"] : searchParams && searchParams["xid"] ? searchParams["xid"] : null;
        var isXidFound = true;
        if (requireXID) {
            isXidFound = this.findXidFromProxyList(xid).isXidFound;
            //debugger;
        }
        var { Allowed } = this.state;
        if (Allowed === undefined) { Allowed = true }
        var MissingFeatures = activeFeatures == null || activeFeatures.length == 0;

        if (this.state.match) {
            if (this.props.isLoggedIn) {
                if (!MissingFeatures && ((!this.props.hasMyChart || (isProxyUser && this.props.blockProxyUsers)) || !Allowed || !isXidFound || (RequireMyChart && isMyChartInActive))) {
                    // in the event that we don't have MyChart where we should, just go back to the root of the site
                    //debugger;
                    //console.info(`RoutPortalLoggedIn Doing a redirect. not MissingFeatures? '${!MissingFeatures}', not hasMyChart? '${!this.props.hasMyChare}', isProxyUser? '${isProxyUser}', blockProxyUsers? '${this.props.blockProxyUsers}', not Allowed, '${!Allowed}', not isXidFound? '${!isXidFound}'`);
                    return <Redirect push to="/" />;
                }
                else {
                    //console.info(`RoutPortalLoggedIn Doing super.render(). not MissingFeatures? '${!MissingFeatures}', not hasMyChart? '${!this.props.hasMyChare}', isProxyUser? '${isProxyUser}', blockProxyUsers? '${this.props.blockProxyUsers}', not Allowed, '${!Allowed}', not isXidFound? '${!isXidFound}'`);
                    return super.render();
                }
            }
            else {
                //alert("redering a redirect here");
                //debugger;
                return <Redirect push to='/login' />;
            }
        }
        else {
            return "";
        }
    }

}


const mapStateToProps = (state, ownProps) => {
    return {
        isLoggedIn: state.domain.li,
        hasMyChart: ownProps.RequireMyChart ? state.domain.hm : true,
        isProxyUser: state.domain.ip,
        activeFeatures: state.memberships.activeFeatures,
        currentUser: state.memberships.currentUser,
        myProxies: state.memberships.proxyList,
        isMyChartInActive: state.dashboard.isMyChartInActive
        //store: window.store,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setRedirectUrl: (currentURL, params) => {
            //debugger;
            dispatch({ type: types.SET_REDIRECT_URL, URL: currentURL, params });
        },
        hideBannerOnCrash: (value) => {
            dispatch({ type: types.HIDE_BANNER_ON_CRASH, value });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RoutePortalLoggedIn);

